<template>
  <div>
    <b-card-body>
      <b-card class="ResultContainer">
        <div class="center">
          <p>
            <span v-if="status == false && error == false && warning == false" class="load">{{ $t('aguarde-0') }}</span>
            <span v-else-if="status == true && error == false && warning == false" class="sucesso">{{
              $t('simulado-com-sucesso') }}</span>
            <span v-else-if="status == true && error == true && warning == false" class="erros">{{
              $t('simulado-com-erros') }}</span>
            <span v-else-if="status == false && error == true && warning == true" class="erros">{{
              $t('simulado-com-erros') }}</span>
            <span v-else-if="status == false && error == true && warning == false" class="erros">{{
              $t('simulado-com-erros') }}</span>
            <span v-else-if="status == true && error == true && warning == true" class="erros">{{ $t('simulado-com-erros')
            }}</span>
            <span v-else-if="status == true && error == false && warning == true" class="warnings">{{
              $t('simulado-com-alertas') }}</span>
            <span v-else-if="status == false && error == false && warning == true" class="warnings">{{
              $t('simulado-com-alertas') }}</span>
          </p>
        </div>

        <div class="timeMsg" v-if="this.simulationTime">{{ $t('tempo-decorrido') }}
          {{ this.simulationTime.toString().replace(".", ",") }}
          {{ $t('seg-0') }}
        </div>

        <div class="base">
          <div class="table-responsive-md table-wrapper-scroll-y my-custom-scrollbar">
            <table class="table table-hover table-sm">
              <img class='loading' v-if="this.waiting" src="@/assets/loading.gif" />
              <span v-else>
                <thead class="thead-dark">
                  <th scope="col">{{ $t('alertas-e-ocupacoes') }}</th>
                </thead>
                <template v-if="this.tableItens.length == 0">{{ $t('sem-dados-para-visualizacao') }}<br /></template>
                <tbody v-else>
                  <tr v-for="item, idx in this.tableItens" :key="idx">
                    <td class="text-truncate table-text">
                      {{ item }}
                    </td>
                  </tr>
                </tbody>
              </span>
            </table>
          </div>
        </div>

        <div class="groupBtn">
          <img v-if="error == false && status == true" id="confirmResultImage" class="float-right"
            src="@/assets/assinarEconfirmar.png" style="margin-left: 30px;" :title="$t('confirmar')"
            :alt="$t('confirmar')" @click="() => {
              confirm()
            }" />
          <img id="stopSimulatorImage" v-if="!status && !error" src="@/assets/stop.png" :title="$t('parar-simulacao')"
            :alt="$t('parar-simulacao')" @click="stopSimulation()" />
          <img id="closeModalPassword" class="float-right" src="@/assets/sair.png" style="margin-left: 30px;"
            :title="$t('cancelar')" :alt="$t('cancelar')" @click="closeModal()" />
        </div>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
import { showError } from "@/global";

export default {
  name: "SimulatorResult",
  watch: {
    result() {
      this.resultSimulator();
    },

  },
  props: ["result", "table"],
  data: function () {
    return {
      waiting: true,
      simulationTime: null,
      resultCalc: 0,
      json: [],
      status: false,
      error: false,
      warning: false,
      tableItens: []

    }
  },
  methods: {
    closeModal() {
      if (this.waiting) {
        showError(this.$t('necessario-aguardar-ou-parar-a-simulacao'))
      }
      else {
        this.$bvModal.hide('resultSimulation')
      }
    },
    stopSimulation() {
      this.waiting = false
      this.simulationTime = null
      this.$bvModal.hide('resultSimulation')
      this.$emit("stopSimulation")
    },
    resultSimulator() {
      if (this.result != null) {
        this.status = this.result.status
        this.error = this.result.errors
        this.warning = this.result.warnings
        this.tableItens = this.result.simulationMessage
        this.simulationTime = this.result.simulationTimeFront
        this.waiting = false
      } else { return }
    },

    confirm() {
      this.$emit("resultado")
      this.simulationTime = null
      this.$bvModal.hide('resultSimulation')
    },

    txtLimits(str) {
      if (str.length > 21) {
        return str.substring(0, 19) + " ..."
      }
      return str;
    },
  },
  created() {

  }
};
</script>

<style scoped>
.timeMsg {
  font-size: 0.8em;
  margin-bottom: 5px;
  text-align: center;
}

.ResultContainer {
  max-width: 800px;
  min-height: 350px;
  display: grid;
  grid-template-rows: auto auto auto;
}

.center {
  text-align: center;
}

.my-custom-scrollbar {
  max-height: 210px;
  overflow: auto;
  margin: 0px auto;
  padding-left: 0px;
  padding-right: 0px;
  min-width: 200px;
}

.my-custom-scrollbar th {
  position: sticky;
  top: 0;
}

.base {
  height: 250px;
  max-width: 680px;
  min-width: 200px;
}

img.loading {
  height: 200px;
  background-clip: content-box;
  background-size: contain;
  align-self: center;
  overflow: hidden !important;
}

tr td {
  white-space: pre-wrap;
}

p {
  font-size: 25px;
  font-weight: 600;
}

.load {
  color: rgba(128, 128, 128, 0.733);
}

.sucesso {
  color: rgb(36, 221, 36);
}

.erros {
  color: red;
}

.warnings {
  color: #ff8d33;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.groupBtn img {
  max-height: 35px;
  cursor: pointer;
}

#stopSimulatorImage {
  max-height: 28px;
  border-radius: 4px;
  align-self: center;
}

.table {
  display: flex;
  flex-direction: column;
}

thead>th {
  display: block;
  width: 680px;
}

.table-text {
  font-family: Arial;
  font-size: 11px;
  text-align: justify;
}

#filter-tree {
  border: 2px solid black;
  border-radius: 4px;
}

@media (max-width: 991px) {
  thead>th {
    width: 367px;
  }
}
</style>
